module.exports = __webpack_public_path__ + "static/media/park-origin-28-70-sq-m.5a48f2ce.jpg";